export interface Testimonial {
  id: number;
  name: string;
  role: string;
  avatarSeq: string;
  text: string;
  type: "text" | "image";
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Online Shopper, NYC",
    avatarSeq: "avatar-1",
    text: "ItaobuySpreadsheet completely changed how I shop online. I used to spend hours comparing prices across different sites, but now I just pull up the spreadsheet and find everything I need in minutes. The curated product lists are always up to date, and the price comparison feature has saved me hundreds of dollars already.",
    type: "text",
  },
  {
    id: 2,
    name: "James Cooper",
    role: "Small Business Owner, LA",
    avatarSeq: "avatar-2",
    text: "As someone who sources products regularly, ItaobuySpreadsheet is a game-changer. The structured data makes it so easy to compare suppliers, check price trends, and make informed purchasing decisions. I have recommended it to everyone in my network.",
    type: "text",
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "Fashion Blogger, Miami",
    avatarSeq: "avatar-3",
    text: "I discovered ItaobuySpreadsheet through a friend and honestly I wish I had found it sooner. The beginner-friendly interface made it super easy to get started even though I am not tech-savvy at all. Now I use it every single week for my hauls and product reviews.",
    type: "image",
  },
  {
    id: 4,
    name: "David Thompson",
    role: "E-commerce Consultant, Chicago",
    avatarSeq: "avatar-4",
    text: "After trying multiple spreadsheet-based shopping tools, ItaobuySpreadsheet stands out for its simplicity and reliability. The filters are intuitive, the lists are comprehensive, and the update frequency keeps everything fresh. It is now an essential part of my sourcing toolkit.",
    type: "image",
  },
  {
    id: 5,
    name: "Olivia Chen",
    role: "Student &amp; Deal Hunter, Austin",
    avatarSeq: "avatar-5",
    text: "Being a student on a budget, every dollar matters. ItaobuySpreadsheet helps me find the best deals across all my favorite categories without having to jump between dozens of browser tabs. The 30-60% savings claim is real — I have experienced it firsthand many times!",
    type: "text",
  },
];